/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingPlanDefinitionListSortCriteria {
    getFixupPrototypeFunction() { return BillingPlanDefinitionListSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<BillingPlanDefinitionListSortCriteria>): BillingPlanDefinitionListSortCriteria {
        let obj = Object.assign(new BillingPlanDefinitionListSortCriteria(), model);
        BillingPlanDefinitionListSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingPlanDefinitionListSortCriteria>): BillingPlanDefinitionListSortCriteria {
        if (!model) return null;
        return BillingPlanDefinitionListSortCriteria.newInstance(<BillingPlanDefinitionListSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingPlanDefinitionListSortCriteria) {
        if (!obj) return;

        models.BillingPlanDefinitionListSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingPlanDefinitionListSortCriteria): boolean {
        Object.setPrototypeOf(obj, BillingPlanDefinitionListSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.BillingPlanDefinitionListSortColumn;

    ascending: boolean;

}
